

import { Mail, Phone, MessageCircle, Clock } from "lucide-react";
import { motion } from "framer-motion";
// import emailjs from 'emailjs-com';
import { useState } from 'react';
import toast from 'react-hot-toast';

export const ContactSection = () => {
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      const scriptURL = "https://script.google.com/macros/s/AKfycby1CwS9EQ3FVLRtJ61kc1hcRn9SxgblFyARX0-FUaqAy5Hj0mGBzjOlbLpDOX-KY2g-/exec"; // 👈 apna web app URL yahan dalna

      const params = new URLSearchParams();
      params.append("name", formData.name);
      params.append("email", formData.email);
      params.append("message", formData.message);

      const res = await fetch(`${scriptURL}?${params.toString()}`, {
        method: "GET",
      });

      const text = await res.text();

      if (text === "Success") {
        toast.success("Message Sent!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error("⚠️ Failed to send message!");
    }
  };


  return (
    <motion.section
      id="contact"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      viewport={{ once: true }}
      className="relative py-24   bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden"
    >
      {/* Animated background elements */}
      <div className="absolute top-10 left-10 w-24 h-24 bg-blue-500 rounded-full opacity-5 animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-emerald-500 rounded-full opacity-5 animate-bounce delay-1000"></div>

      {/* Top marquee */}
      <div className="absolute top-0 w-full overflow-hidden bg-gradient-to-r from-blue-600 to-emerald-500 py-3">
        <div className="whitespace-nowrap animate-marquee text-white text-sm font-semibold uppercase tracking-wider">
          <span className="mx-8">🚀 Let's Build Your Dream Website •</span>
          <span className="mx-8">💼 Fast Delivery — Professional Design •</span>
          <span className="mx-8">📱 Fully Mobile Friendly •</span>
          <span className="mx-8">🌐  Hosting Guidance •</span>
          <span className="mx-8">💬 24/7 WhatsApp Support •</span>
        </div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10 mt-16 px-6 md:px-12">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-emerald-500 text-transparent bg-clip-text inline-block mb-4">
            Let's Bring Your Vision to Life
          </h2>
          <p className="text-sm md:text-lg  text-gray-600 max-w-2xl mx-auto">
            Ready to create something amazing? Let's discuss your project and turn your ideas into reality.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          {/* Left Content - Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="lg:col-span-2 space-y-8"
          >
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Get In Touch</h3>
              <p className="text-gray-600 mb-6">
                Have a project in mind? Let's collaborate to create a stunning website that represents your brand perfectly.
              </p>

              <div className="space-y-4">
                <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <Phone className="text-blue-600" size={20} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-[10px] sm:text-[16px]">Call / WhatsApp</h4>
                    <a href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
                      className="text-blue-600 hover:underline block mt-1 text-[9px] sm:text-[16px]">
                      +92 311 2891862
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-emerald-50 rounded-xl">
                  <div className="bg-emerald-100 p-3 rounded-lg">
                    <Mail className="text-emerald-600" size={20} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-[10px] sm:text-[16px]">Email</h4>
                    <a href="mailto:mominhussain446@gmail.com"
                      className="text-emerald-600 hover:underline block mt-1 text-[9px] sm:text-[16px]">
                      mominhussain446@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-purple-50 rounded-xl">
                  <div className="bg-purple-100 p-3 rounded-lg">
                    <Clock className="text-purple-600" size={20} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-[10px] sm:text-[16px]">Response Time</h4>
                    <p className="text-purple-600 mt-1 text-[9px] sm:text-[16px]">Within 2 hours</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Why Work With Me</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-gray-600">Fast project delivery</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-gray-600">Professional communication</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-gray-600">Ongoing support</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-gray-600">Mobile-first approach</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Side - Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="lg:col-span-3"
          >
            <div className="bg-gradient-to-br from-blue-600 to-emerald-500 rounded-2xl p-5 sm:p-8 shadow-2xl">
              <div className="bg-white rounded-2xl p-5 sm:p-8  shadow-lg">
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    Send a Message
                  </h3>
                  <p className="text-gray-600">
                    Fill out the form below and I'll get back to you as soon as possible
                  </p>
                </div>



                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label
                        htmlFor="name"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Your Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full border border-gray-300 p-4 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Your Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full border border-gray-300 p-4 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="message"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Your Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      placeholder="Tell me about your project..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="w-full border border-gray-300 p-4 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition resize-none"
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-blue-600 to-emerald-500 text-white py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2"
                  >
                    Send Message
                  </button>
                </form>

                <p className="text-center text-gray-500 text-sm mt-6">
                  I typically respond within 2 hours during business hours
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom CTA */}
        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Prefer to chat directly?</h3>
            <p className="text-gray-600 mb-6">
              Reach out via WhatsApp for instant communication and quick responses.
            </p>
            <a
              href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-green-700 transition-colors duration-300"
            >
              <MessageCircle size={20} />
              Message on WhatsApp
            </a>
          </div>
        </motion.div>
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 20s linear infinite;
        }
      `}</style>
    </motion.section>
  );
};